import React from 'react';
import { twMerge } from 'tailwind-merge';

import { LoggerFn } from '../../../app/Shared/types';

type Props = {
  logger: LoggerFn;
  BetaBadgeClasses: string;
  imagesUrl: string;
};

const StoryboardCtaButton = ({
  logger,
  BetaBadgeClasses,
  imagesUrl,
}: Props) => {
  return (
    <a
      className="bg-blue-100 rounded-lg lg:inline-block px-3 ppro-lg:px-5 py-2 ppro-lg:py-3 m-0 text-sm text-gray-900"
      href={STORYBOARD_CTA.url}
      onClick={() => logger('nav.clickStoryboard')}
    >
      <span className="hidden ppro-lg:inline">{STORYBOARD_CTA.buttonText}</span>
      <img
        src={`${imagesUrl}/icons/${STORYBOARD_CTA.icon}`}
        className="ppro-lg:w-6 ppro-lg:px-1 ppro-lg:inline "
        alt={STORYBOARD_CTA.altText}
      />
      {STORYBOARD_CTA.isBeta && (
        <span
          className={twMerge(BetaBadgeClasses, 'hidden ppro-lg:inline ml-1')}
        >
          Beta
        </span>
      )}
    </a>
  );
};

export const STORYBOARD_CTA = {
  altText: 'Storyblocks with AI logo',
  buttonText: 'Storyblocks with',
  url: '/storyblocks-with-ai/new',
  icon: 'storyboard-ai-logo.svg',
  isBeta: true,
};

export default StoryboardCtaButton;
